const ROUTES_ILLUSTRATIONS = [
  ['/finance', 'tresorerie'],
  ['/pricing-rules', 'tresorerie'],
  ['/trucks', 'flotte'],
  ['/drivers', 'chauffeur'],
  ['/orders', 'commandes'],
  ['/dispatch', 'repartition'],
  ['/stock', 'stock'],
  ['/stations/pos', 'station'],
  ['/stations/kpis', 'station'],
  ['/stations/purchases', 'station'],
  ['/stations', 'station'],
  ['/rentals', 'location'],
  ['/invoices', 'documents'],
  ['/documents', 'documents'],
  ['/rapports', 'rapports'],
  ['/daily-reports', 'rapports'],
  ['/tracking', 'suivi'],
  ['/gps-providers', 'integrations'],
  ['/geo-locations', 'zones'],
  ['/alerts', 'conformite'],
  ['/maintenance', 'conformite'],
  ['/mission-integrity', 'conformite'],
  ['/parametres/blocages', 'conformite'],
  ['/users', 'administration'],
  ['/profile', 'administration'],
  ['/organizations', 'administration'],
  ['/audit', 'administration'],
  ['/licenses', 'administration'],
  ['/openwa', 'integrations'],
  ['/backend-ops', 'integrations'],
  ['/search', 'recherche'],
  ['/client-portal', 'clients'],
  ['/clients', 'clients'],
  ['/companies', 'clients'],
  ['/control-fuel', 'carburant'],
  ['/operations', 'transport'],
  ['/trips', 'transport'],
  ['/field-ops', 'transport'],
  ['/onboarding', 'transport'],
];

export const illustrationPourEntete = (pathname) => {
  const route = ROUTES_ILLUSTRATIONS.find(
    ([prefixe]) => pathname === prefixe || pathname.startsWith(`${prefixe}/`),
  );
  if (route) return route[1];
  return undefined;
};
